export const flags = ['moduleSharing', 'dataExport', 'distributionList', 'knowledgeGraph', 'templateReferenceAction', 'formsV2'] as const;

export type FeatureFlag = (typeof flags)[number];

export type FeatureFlags = Record<FeatureFlag, boolean>;

export type FeatureFlagResponse = { checkedAt: string; flags: FeatureFlags };
